import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import { MainNavbar } from "../core";
import routesService from "../service/routeService";
import { getUserProfile } from "../service/auth";

const MainLayout = ({ component: Component, ...rest }) => {
	let navigate = useNavigate();
	let [flag, setFlag] = useState(true);
	useEffect(() => {
		try {
			let userProfile = getUserProfile();
			if (!userProfile?.token) return navigate(routesService.getLoginRoute());
			setFlag(false);
		} catch (error) {}
	}, [navigate]);
	if (flag) return <></>;

	return (
		<Fragment>
			<MainNavbar />
			<Container fluid className="main-content-height main-content-overflow">
				<Component />
			</Container>
		</Fragment>
	);
};
export default MainLayout;
